import sliceCreator from '../../index.js';
import {STORE_MANAGER_EDIT_STOCK} from '../../../constants/index.js';
const _editStockManagementAction = sliceCreator('STORE_MANAGER_EDIT_STOCK', STORE_MANAGER_EDIT_STOCK, 'put');

const { asyncAction: editStockManagementAction, reducer, clearData: clearEditStockManagementAction } = _editStockManagementAction;

export default reducer;

export {
    editStockManagementAction,
    clearEditStockManagementAction
}